import { useState, useEffect } from "react";
import dayjs from "dayjs";
import { fetchFilteredInventory } from "../../http/api";

export const useInventoryData = (
  token,
  input,
  page,
  itemsPerPage,
  source = "noSource",
  sortConfigForFetchingData = null
) => {
  const [bondData, setBondData] = useState([]);
  const [totalElements, setTotalElements] = useState(0);
  const [lastUpdatedAt, setLastUpdatedAt] = useState(null);
  const [loading, setLoading] = useState(true);

  // Determine the effective source - if input has filters, treat as filtered source
  const effectiveSource =
    input && Object.keys(input || {}).filter((key) => key !== "source").length > 0
      ? "filteredSource"
      : source;

  useEffect(() => {
    const fetchInventory = async () => {
      setLoading(true);
      try {
        // Remove source from input to prevent it from being sent to the backend
        const { source: _source, ...cleanInput } = input || {}; // Destructure source out

        const payload = {
          ...cleanInput,
          page,
          size: itemsPerPage,
          ...(sortConfigForFetchingData && {
            columnToSort: sortConfigForFetchingData.columnToSort,
            sortingDirection: sortConfigForFetchingData.sortingDirection,
          }),
        };

        // If filteredSource or yieldtable but no valid input, skip the fetch
        if (
          (effectiveSource === "filteredSource" || effectiveSource === "yieldtable" || effectiveSource === "viewInventoryBondChar" || effectiveSource === "viewInventoryLadder") &&
          (!cleanInput || Object.keys(cleanInput).length === 0)
        ) {
          return; // Early return if no input for filteredSource or yieldtable
        }

        const data = await fetchFilteredInventory(token, payload);
        setBondData(data.content);
        setTotalElements(data.totalElements);
        setLastUpdatedAt(dayjs().toISOString());
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    // Execute fetch based on the effective source
    if (effectiveSource === "noSource") {
      fetchInventory();
    } else if (effectiveSource === "filteredSource" || effectiveSource === "yieldtable" || effectiveSource === "viewInventoryBondChar" || effectiveSource === "viewInventoryLadder") {
      if (input) {
        fetchInventory();
      }
    }
  }, [token, input, page, itemsPerPage, sortConfigForFetchingData, effectiveSource]);

  return {
    bondData,
    totalElements,
    lastUpdatedAt,
    loading,
    source: effectiveSource,
  };
};
